export default "__VITE_ASSET__DszlS4mH__"